export { InstitutionActivityBranchesInfo } from './InstitutionActivityBranchesInfo'
